import { memo } from "react";
import { Alert, Stack, Collapse } from "@mui/material";
import { useTheme } from "@mui/material/styles";

function FeedbackMessage({ errors = [], msg = "" }) {
  const theme = useTheme();

  return (
    <Stack
      spacing={1}
      sx={{
        width: "100%",
        mt: 2,
      }}
    >
      {errors.map((error, index) => (
        <Collapse key={index} in>
          <Alert
            severity="error"
            variant="filled"
            sx={{
              bgcolor: theme.palette.background.error,

              color: "#fff",

              "& .MuiAlert-icon": {
                color: "#fff",
              },
            }}
          >
            {error}
          </Alert>
        </Collapse>
      ))}

      {!!msg && (
        <Collapse in>
          <Alert
            severity="success"
            variant="filled"
            sx={{
              bgcolor: theme.palette.background.success,

              color: "#fff",

              "& .MuiAlert-icon": {
                color: "#fff",
              },
            }}
          >
            {msg}
          </Alert>
        </Collapse>
      )}
    </Stack>
  );
}

export default memo(FeedbackMessage);
